<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Servicios (${services.length})`,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <router-link to="/service/0" class="btn main-bg">
          <i class="fa fa-plus mr-1"></i>Nueva surcursal
        </router-link>

        <div style="overflow-y: auto; max-height: 70vh; overflow-x: auto">
          <table class="table" id="list-supliers">
            <thead class="thead-light">
              <tr>
                <th>Nombre del servicio</th>
                <th>Cantidad</th>
                <th class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading && services.length === 0">
                <td class="text-center" colspan="8">
                  <Loader />
                </td>
              </tr>
              <tr v-for="service in services" :key="service.id">
                <td>{{ service.Name || "N/A" }}</td>
                <td>{{ service.Amount }}</td>

                <td class="text-center">
                  <router-link
                    :to="`service/${service.Id}`"
                    title="Detalles"
                    class="text-info mr-2"
                  >
                    <i class="fa fa-edit"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  name: "CompaniesList",
  components: {
    Loader,
    Breadcrumbs,
  },
  data: function () {
    return {
      services: [],
      servicesTypes: [],
      loading: false,
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 7,
      },
      companyService: new CompanyService(),
    };
  },
  methods: {
    async getServices() {
      try {
        this.loading = true;
        const res = await this.companyService.getServices();
        this.services = res.data;

        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");

        this.loading = false;
      }
    },
  },
  mounted: async function () {
    await this.getServices();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/colors";
.w100 {
  width: 100%;
}
h3 {
  margin: 40px 0 0;
}
.form-panel {
  border: solid 0.1em #ccc;
  border-radius: 4px;
  margin: 4px 0 5px 0;
}
td,
th {
  font-weight: 400;
}
.fa {
  font-size: 1.2rem;
}
</style>
